export const titles = [
	{ label: "Inventario", link: "/inventario", class: "showInventory" },
	{
		label: "Envases vacíos",
		link: "/envases_vacios",
		class: "showEmpty",
	},
];

export const head_table = [
	{ name: "", size: 3, order: "" },
	{ name: "Nombre Comercial", size: 20, order: "NOMBRE_COMERCIAL" },
	{
		name: "Ingrediente activo",
		size: 10,
		order: "INGREDIENTE_ACTIVO",
	},
	{
		name: "Aptitud",
		size: 10,
		order: "APTITUD",
	},
	{
		name: "Cantidad",
		size: 8,
		order: "CANTIDAD_ENVASES",
	},
	{ name: "Stock actual", size: 8, order: "STOCK", class: "" },
	{
		name: "U.M",
		size: 5,
		order: "UNIDAD_DE_MEDIDA",
	},
	{ name: "Acción", size: 2, order: "" },
	{ name: "", size: 3, order: "" },
];

export const baseUnit = [
	{
		value: "u1",
		label: "Un",
	},
	{
		value: "c1",
		unit_measurement: "cc",
	},
	{
		value: "c1000",
		unit_measurement: "L",
	},
	{
		value: "g1",
		unit_measurement: "g",
	},
	{
		value: "g1000",
		unit_measurement: "Kg",
	},
	{
		value: "g1000000",
		unit_measurement: "Tn",
	},
];

export const item = {
	inventory_id: "",
	product_id: "",
	quantity: "",
	initially_loaded: 0,
	application_history: 0,
	container_content: "",
	dealer_id: "",
	dealer_number: "",
	expiration_date: "",
	lot: "",
	quantity_lot: "",
	price: "",
	price_total: "",
	tradename: "",
	type_currency: "",
	type_product: "",
	unit_measurement: "",
	value_unit_measurement: 1000,
	billing_date: "",
	save_as: "",
};

export const baseFilters = {
	page: 1,
	paginate: 10,
	order: "NOMBRE_COMERCIAL",
	orderType: "asc",
	defaultUnit: 1000,
	expired: true,
	business: "",
	formula: "",
	cas: "",
	createdDate: "",
	createdDateTo: "",
	aptitudeID: "",
	showUsage: false,
	showGeneric: false,
	showInitiallyLoaded: false,
	random: false,
};
